import api from './axios';

export const listar = () => api.get('/usuarios/');
export const criar = (data) => api.post('/usuarios/', data);
export const atualizar = (id, data) => api.patch(`/usuarios/${id}`, data);
export const resetarSenha = (id, novaSenha) => api.post(`/usuarios/${id}/resetar-senha`, { nova_senha: novaSenha });
